import { gql } from '@apollo/client';
/**
 * @const OrderInDealMutation
 * @since 1.0.0
 */
export const OrderInDealMutation = gql `
  mutation OrderInDealMutation($input: OrderInDealInput!) {
    orderInDeal(input: $input) {
      id
    }
  }
`;
